var _mask, _rect, _mask2, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomsItemDescription(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3333_24313",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 6.26087,
    rx: 0.508696
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 6.26087,
    rx: 0.508696,
    stroke: "#828282",
    strokeWidth: 2.8,
    mask: "url(#path-1-inside-1_3333_24313)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_3333_24313",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.5625,
    y: 5,
    width: 14.8696,
    height: 10.1739,
    rx: 0.508696
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5625,
    y: 5,
    width: 14.8696,
    height: 10.1739,
    rx: 0.508696,
    stroke: "#828282",
    strokeWidth: 2.8,
    mask: "url(#path-2-inside-2_3333_24313)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.82422,
    y: 8.13086,
    width: 3.13043,
    height: 0.782609,
    rx: 0.391304,
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomsItemDescription);
export default __webpack_public_path__ + "static/media/customs-item-description.78af05d0.svg";
export { ForwardRef as ReactComponent };